(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero_banner_slide-bkp"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function () {

  

// $(window).on('scroll', function () {
//     let scrollTop = $(this).scrollTop();
//     let windowHeight = $(window).height();

//     $('.hero-banner-info').each(function () {
//         let $target = $(this);
//         let targetOffsetTop = $target.offset().top;
//         let targetHeight = $target.outerHeight();
//         let targetBottom = targetOffsetTop + targetHeight + 100;

//         // Trigger when bottom is within 200px of viewport bottom
//         if (scrollTop + windowHeight >= targetBottom ) {
//             if (!$target.hasClass('herobanner')) {
//                 $target.addClass('herobanner');
//                 // console.log('Added herobanner to one section');
//             }
//         } else {
//             if ($target.hasClass('herobanner')) {
//                 $target.removeClass('herobanner');
//                 // console.log('Removed herobanner from one section');
//             }
//         }
//     });
// });



  
  // function initDesktopAnimations() {
  //   gsap.registerPlugin(ScrollTrigger);
  //   ScrollTrigger.defaults({
  //     markers: false,
  //   });

  //   // Animate text opacity out on scroll
  //   gsap.utils.toArray('.banner_component').forEach(element => {
  //     const text = element.querySelector('.hero-banner-text');
  //     if (text) {
  //       gsap.to(
  //         text,
  //         {
  //           opacity: 0,
  //           ease: "power4.out",
  //           scrollTrigger: {
  //             trigger: element,
  //             start: "90% top",
  //             end: "100% top",
  //             scrub: 1,
  //           },
  //         }
  //       );
  //     }
  //   });
  // }

  // Initialize animations for large screens only
  if (window.innerWidth > 1100) {
    initDesktopAnimations();
  }

});


  
  
$(document).ready(function () {
  // Function to initialize desktop animations
  function initDesktopAnimations() {
    gsap.registerPlugin(ScrollTrigger);

    // Set default ScrollTrigger configurations
    ScrollTrigger.defaults({
      markers: false, // Turn markers off for production
      scrub: 1,       // Make animation smooth with scrub effect
    });

    // Targeting all sections with the class 'hero-banner-info'
    $('.hero-banner-info').each(function (index, element) {
      const text = $(element).find('.hero-banner-text');
      const contentImage = $(element).find('.hero-banner-image img');

      // Animate text
      if (text.length) {
        gsap.to(text, {
          y: -50,             // Move upward 50px
          opacity: 0,         // Fade out
          ease: "power2.inOut",
          scrollTrigger: {
            trigger: element,
            start: "80% center",   // Start earlier for smoother transition
            end: "100% top",
            scrub: true,
          },
        });
      }

      // Animate image
      if (contentImage.length) {
        gsap.to(contentImage, {
          y: 0,             // Move upward 30px
          opacity: 0.3,       // Slight fade out
          scale: 1,        // Slight zoom-out effect for depth
          ease: "power2.inOut",
          scrollTrigger: {
            trigger: element,
            start: "80% center",
            end: "100% top",
            scrub: true,
          },
        });
      }
    });

  }

  // Only initialize desktop animations if the window width is greater than 1100px
  
    initDesktopAnimations();
 
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero_banner_slide"] && !Shopify.designMode) return;
  try {
    
function initializeHeroBanner() {
  if (window.ascHeroBannerController) {
    window.ascHeroBannerController.refresh();
    return;
  }

  let animationFrame = null;

  const update = () => {
    animationFrame = null;
    const scrollTop = window.scrollY;
    const windowHeight = window.visualViewport?.height || window.innerHeight;

    document.querySelectorAll('.hero-banner-info').forEach(function (target) {
      const targetOffsetTop = target.getBoundingClientRect().top + scrollTop;
      const targetBottom = targetOffsetTop + target.offsetHeight + 100;
      target.classList.toggle('herobanner', scrollTop + windowHeight >= targetBottom);

    });

    document.querySelectorAll('.banner_component').forEach((element) => {
      const text = element.querySelector('.hero-banner-text');
      if (!text) return;

      if (window.innerWidth <= 1100) {
        text.style.removeProperty('opacity');
        return;
      }

      const elementTop = element.getBoundingClientRect().top + scrollTop;
      const fadeStart = elementTop + element.offsetHeight * 0.9;
      const fadeEnd = elementTop + element.offsetHeight;
      const progress = Math.min(1, Math.max(0, (scrollTop - fadeStart) / Math.max(fadeEnd - fadeStart, 1)));
      text.style.opacity = String(1 - progress);
    });
  };

  const refresh = () => {
    if (animationFrame !== null) return;
    animationFrame = window.requestAnimationFrame(update);
  };

  window.ascHeroBannerController = { refresh };
  window.addEventListener('load', refresh, { once: true });
  window.addEventListener('scroll', refresh, { passive: true });
  window.addEventListener('resize', refresh, { passive: true });
  document.addEventListener('shopify:section:load', refresh);

  refresh();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeHeroBanner, { once: true });
} else {
  initializeHeroBanner();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.ascImageBannerController) {
    window.ascImageBannerController.refresh();
    return;
  }

  const lifecycleController = new AbortController();
  const { signal } = lifecycleController;
  const bannerVideoMedia = window.matchMedia("(max-width: 749px)");
  let bannerHeightFrame = null;

  function syncBannerVideos() {
    document.querySelectorAll('[data-banner-video-root]').forEach((banner) => {
      const desktopVideo = banner.querySelector('[data-banner-video="desktop"]');
      const mobileVideo = banner.querySelector('[data-banner-video="mobile"]');
      const useMobile = bannerVideoMedia.matches;
      const activeVideo = useMobile && mobileVideo?.querySelector('source')?.dataset.src
        ? mobileVideo
        : desktopVideo;

      [desktopVideo, mobileVideo].forEach((video) => {
        if (!video) return;

        const source = video.querySelector('source');
        if (!source) return;

        if (video === activeVideo) {
          if (!source.src && source.dataset.src) {
            source.src = source.dataset.src;
            video.load();
          }
          video.play().catch(() => {});
          return;
        }

        video.pause();
        if (source.hasAttribute('src')) {
          source.removeAttribute('src');
          video.load();
        }
      });
    });
  }

  function bannerHeight() {
    document.querySelectorAll('[data-banner-video-root]').forEach((banner) => {
      if (!bannerVideoMedia.matches) {
        banner.style.removeProperty("--mobile-banner-height");
        return;
      }

      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const bannerTop = banner.getBoundingClientRect().top + window.scrollY;
      const heightBanner = Math.max(1, viewportHeight - bannerTop - 80);

      banner.style.setProperty("--mobile-banner-height", heightBanner + "px");
    });
  }

  function scheduleBannerHeight() {
    if (signal.aborted) return;
    if (bannerHeightFrame) return;
    bannerHeightFrame = window.requestAnimationFrame(() => {
      bannerHeightFrame = null;
      if (signal.aborted) return;
      bannerHeight();
    });
  }

  function refresh() {
    if (signal.aborted) return;
    syncBannerVideos();
    scheduleBannerHeight();
  }

  function destroy() {
    if (bannerHeightFrame) {
      window.cancelAnimationFrame(bannerHeightFrame);
      bannerHeightFrame = null;
    }
    lifecycleController.abort();
    delete window.ascImageBannerController;
  }

  window.ascImageBannerController = { refresh, destroy };

  window.addEventListener("load", refresh, { once: true, signal });
  window.addEventListener("resize", scheduleBannerHeight, { passive: true, signal });
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", scheduleBannerHeight, { passive: true, signal });
  }

  const handleMediaChange = () => refresh();
  if (bannerVideoMedia.addEventListener) {
    bannerVideoMedia.addEventListener("change", handleMediaChange, { signal });
  } else {
    bannerVideoMedia.addListener(handleMediaChange);
    signal.addEventListener("abort", () => bannerVideoMedia.removeListener(handleMediaChange), { once: true });
  }

  document.addEventListener("shopify:section:load", refresh, { signal });
  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videowise-banner"] && !Shopify.designMode) return;
  try {
    

  function bannerHeight(){
     const windowHeight = window.innerHeight;
      const belowSection = document.querySelector(".home-collection-section");
      const banner = document.querySelector(".main-banner-image"); 
      let sec = belowSection.offsetHeight - 20;
      let heightBanner = windowHeight - sec;
      banner.style.height = heightBanner + "px";
    // console.log('Load');
  }
    window.addEventListener("load", bannerHeight);
  window.addEventListener("resize", bannerHeight);
  

  } catch(e) { console.error(e); }
})();
})();
